import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { QUIZ_QUESTIONS, RECOMMENDATIONS } from './QuizData';

function Quiz() {
    const [step, setStep] = useState(0);
    const [answers, setAnswers] = useState({});
    const [result, setResult] = useState(null);

    useEffect(() => {
        // AdSense/Analytics Hook: simpler simulation of page view
        // In production, this would trigger window.gtag('config', 'UA-XXX', {'page_path': `/quiz/step-${step+1}`});
        const url = new URL(window.location);
        url.searchParams.set('step', step + 1);
        window.history.pushState({}, '', url);
    }, [step]);

    const handleOptionClick = (value) => {
        const currentQuestion = QUIZ_QUESTIONS[step];
        const newAnswers = { ...answers, [currentQuestion.id]: value };
        setAnswers(newAnswers);

        if (step < QUIZ_QUESTIONS.length - 1) {
            setStep(step + 1);
        } else {
            // Calculate Result
            calculateResult(newAnswers);
        }
    };

    const calculateResult = (finalAnswers) => {
        // Simple logic for MVP: Combine Energy + Goal
        const key = `${finalAnswers.energy}-${finalAnswers.goal}`;
        const comboPrompt = RECOMMENDATIONS[key] || RECOMMENDATIONS['default'];
        setResult(comboPrompt);
    };

    if (result) {
        return (
            <div className="quiz-container fade-in">
                <span className="meta">YOUR PERSONALIZED PROMPT</span>
                <h1 className="prompt-text">{result}</h1>
                <div className="controls">
                    <button className="gen-btn" onClick={() => {
                        setStep(0);
                        setAnswers({});
                        setResult(null);
                    }}>Reset Prompt Building</button>
                    <Link to="/" className="text-btn">Back to Focus Mode</Link>
                </div>
            </div>
        );
    }

    const currentQ = QUIZ_QUESTIONS[step];
    const progress = ((step) / QUIZ_QUESTIONS.length) * 100;

    return (
        <div className="quiz-container fade-in">
            <Helmet>
                <title>Personalized Prompt Generator | Mindful Journal Prompts</title>
                <meta name="description" content="Get a personalized journal prompt tailored to your current energy and goals. Calibrate your mind in seconds." />
                <link rel="canonical" href="https://www.mindfuljournalprompts.com/personalized-prompt" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Personalized Prompt Generator | Mindful Journal Prompts" />
                <meta property="og:description" content="Get a personalized journal prompt tailored to your current energy and goals. Calibrate your mind in seconds." />
                <meta property="og:url" content="https://www.mindfuljournalprompts.com/personalized-prompt" />
                <meta property="og:site_name" content="Mindful Journal Prompts" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Personalized Prompt Generator | Mindful Journal Prompts" />
                <meta name="twitter:description" content="Get a personalized journal prompt tailored to your current energy and goals. Calibrate your mind in seconds." />
            </Helmet>

            <div className="progress-bar-container">
                <div className="progress-bar" style={{ width: `${progress}%` }}></div>
            </div>

            <span className="meta">PERSONALIZED PROMPT // STEP 0{step + 1}</span>

            <h2 className="quiz-question">{currentQ.question}</h2>

            <div className="options-grid">
                {currentQ.options.map((opt) => (
                    <button
                        key={opt.value}
                        className="option-card"
                        onClick={() => handleOptionClick(opt.value)}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>

            <div className="quiz-footer">
                <Link to="/" className="text-btn">Cancel</Link>
            </div>
        </div>
    );
}

export default Quiz;
